<template lang="pug">
  b-modal#repullDataDetail(
  ref="repullDataDetail"
  :title="$t('ui.repull_data_detail')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  ok-only
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$t('ui.id')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="id"
          type="text"
          v-model="id"
          :disabled="loading"
        )
      b-form-group(:label="$t('ui.from')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="startDate"
          type="text"
          v-model="startDate"
          :disabled="loading"
        )
      b-form-group(:label="$t('ui.to')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="endDate"
          type="text"
          v-model="endDate"
          :disabled="loading"
        )
      b-form-group(:label="$t('ui.action_by')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="actionBy"
          type="text"
          v-model="actionBy"
          :disabled="loading"
        )
      b-form-group(:label="$t('ui.created_on')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="createdOn"
          type="text"
          v-model="createdOn"
          :disabled="loading"
        )
      b-form-group(:label="$t('ui.rb_data')" disabled).mb-3
        b-form-textarea(v-model="rbData" rows="15")
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fas fa-check" :text="$t('ui.ok')" isModal=true)
</template>

<script>
import { required, minLength, maxLength, alphaNum, integer, email, helpers } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import beautify from "xml-beautifier";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      id: "",
      rbData: "",
      createdOn: "",
      startDate: "",
      endDate: "",
      actionBy: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
  },
  validations: {
  },
  methods: {
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.id = this.item.data_id;
      this.createdOn = this.$moment(this.item.created_on).format("YYYY-MM-DD, HH:mm:ss");
      this.startDate = this.$moment(this.item.start_date).format("YYYY-MM-DD");
      this.endDate = this.$moment(this.item.end_date).format("YYYY-MM-DD");
      this.actionBy = this.item.action_by;
      this.rbData = beautify(this.item.rb_data);
    }
  }
};
</script>
